export default {
  'app.setting.pagestyle': 'Réglage du style de page',
  'app.setting.pagestyle.dark': 'Style sombre',
  'app.setting.pagestyle.light': 'Style clair',
  'app.setting.content-width': 'Largeur du contenu',
  'app.setting.content-width.fixed': 'Fixe',
  'app.setting.content-width.fluid': 'Fluide',
  'app.setting.themecolor': 'Couleur de thème',
  'app.setting.themecolor.dust': 'Rouge poussière',
  'app.setting.themecolor.volcano': 'Volcan',
  'app.setting.themecolor.sunset': 'Orange coucher de soleil',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Vert polaire',
  'app.setting.themecolor.daybreak': 'Bleu lever de soleil (par défaut)',
  'app.setting.themecolor.geekblue': 'Bleu geek',
  'app.setting.themecolor.purple': 'Violet doré',
  'app.setting.navigationmode': 'Mode de navigation',
  'app.setting.sidemenu': 'Disposition du menu latéral',
  'app.setting.topmenu': 'Disposition du menu supérieur',
  'app.setting.fixedheader': 'En-tête fixe',
  'app.setting.fixedsidebar': 'Barre latérale fixe',
  'app.setting.fixedsidebar.hint': 'Fonctionne avec la disposition du menu latéral',
  'app.setting.hideheader': 'En-tête caché lors du défilement',
  'app.setting.hideheader.hint': "Fonctionne lorsque l'en-tête caché est activé",
  'app.setting.othersettings': 'Autres réglages',
  'app.setting.weakmode': 'Mode faible',
  'app.setting.copy': 'Copier les réglages',
  'app.setting.copyinfo':
    'Copie réussie, veuillez remplacer defaultSettings dans src/models/setting.js',
  'app.setting.production.hint':
    "Le panneau de réglages n'apparaît que dans l'environnement de développement. Veuillez le modifier manuellement.",
};
